import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {NotificationService} from '../../notification/notification.service';
import {ContactsImportResponse} from '../../api/models/contacts-import-response';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';



@Component({
    selector: 'app-contacts-import-results-dialog',
    template: `
    <h2 mat-dialog-title>
      Contacts Import Results
      <button mat-icon-button style="float: right">
        <mat-icon [mat-dialog-close]="false">close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content class="mat-typography">
      <div>
        <h3>Imported {{data.imported}} contacts</h3>
        <h3>Skipped {{data.skipped}} contacts</h3>
        <h3>Duplicate {{data.duplicate}} contacts</h3>
        <h3>Failed {{data.failed}} contacts</h3>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>

  `,
    standalone: true,
    imports: [
        MatDialogTitle,
        MatIconButton,
        MatIcon,
        MatDialogClose,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
    ],
})
export class ContactsImportResultsDialogComponent implements OnInit, OnDestroy {

  constructor(
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<ContactsImportResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContactsImportResponse,
  ) {

  }

  ngOnInit() {
    console.log(this.data);
  }

  ngOnDestroy() {

  }
}
